/**
 * @author liqiuqi
 * @date 2022 2022/5/11 15:36
 */
/** 行业专区 **/
import { config } from "@/utils/config";
import { omniAxios } from "@/utils/axios";

// 智能订阅弹窗展示数据
export function restAccountIndustryGetBusinessCount({ industryId = "" }) {
  return omniAxios({
    url: config.restAccountIndustryGetBusinessCountPath,
    method: "get",
    params: {
      industryId,
    },
  });
}

// 获取行业专区信息
export function restAccountIndustryQueryIsEnter({ keyword = "" }) {
  return omniAxios({
    url: config.restAccountIndustryQueryIsEnterPath,
    method: "get",
    params: {
      keyword,
    },
  });
}

// 获取行业信息 - 行业专区信息栏tab切换
export function restAccountIndustrySearch({ businessIdList = [], industryId = 0 }) {
  return omniAxios({
    url: config.restAccountIndustrySearchPath,
    method: "post",
    params: {
      areaId: [],
      businessIdList, // tab_index + 1
      dateType: 4,
      industryId, // 行业专区ID
      pageNo: 1,
      pageSize: 5,
    },
  });
}
